/*
 * @Author: liusuyun
 * @Date: 2021-09-27 20:53:02
 * @LastEditors: wuqinfa
 * @LastEditTime: 2024-02-20 16:44:50
 * @Description: 导入
 */
import request from '@/utils/request';

// 导入记录
export async function getImportRecord(params: any) {
  return request('/crm-market/importLog/getImportRecord', {
    method: 'GET',
    params: params,
  });
}

// 导入模板下载
export async function getTemplate(params: any) {
  return request('/crm-market/leadsWhiteList/getTemplate', {
    method: 'GET',
    params: params,
  });
}
